var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006AD2",
    d: "m8.976 18.857l.394-1.067l-.638.06l-.28.715c-.062.139-.122.285-.3.285l-1.463.008l.305-.858H5.378c.007-.105 3.1-7.91 3.22-8.143h2.632c.24.022.375.208.3.448l-.368.945l-1.59 4.252c2.205 0 4.29-1.293 5.235-3.292c.714-1.348.909-3.639-1.192-3.639H5.357l1.088-1.813a.57.57 0 0 1 .525-.316h4.395l.496-1.3h1.44c.09.015.15.09.135.187l-.038.12l-.323.858l-.045.128h.6l.045-.098l.421-1.09c.037-.105.037-.105.135-.105h1.275c.172 0 .24.097.172.27l-.346.933l-.052.127l.112.023c.585.075 1.163.203 1.703.45c.412.188.787.428 1.095.773c.42.465.63 1.012.66 1.635c.037.6-.075 1.184-.278 1.747a9.8 9.8 0 0 1-2.122 3.563c-1.4 1.446-3.257 2.305-5.19 2.782c-.09.023-.135.06-.165.15l-.379 1.015c-.075.188-.15.247-.337.247z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgb);
export default __webpack_public_path__ + "static/media/dgb.341e6e9047dd1f2f1baf2bdd619c1fff.svg";
export { ForwardRef as ReactComponent };